export default "__VITE_ASSET__CAkRArFY__"